const baseUrl = '/manager/kpis/'
export default {
  getMonthlyTotal(kpiId, targetId, month, locale = null) {
    let url = `${baseUrl + kpiId}/targets/${targetId}/monthly_performances/monthly_total?month=${month}`;
    if (locale) {
      url = `/${locale}` + url
    }
    return axios.get(url);
  },
}
